import { I18nDictionary } from '@/components/i18n/lang-context'

export interface RealEstatePartner {
  id: string
  name: string
  logo: string
  logoW: number
  logoH: number
  website: {
    fr: string
    en: string
  }
  email: string
  phone: string
  location: string
  backgroundImages: string[]
  description?: I18nDictionary
}

export const REAL_ESTATE_PARTNERS: RealEstatePartner[] = [
  // {
  //   id: 'chabert',
  //   name: 'Chabert Group',
  //   logo: '/partners/chabert/logo.jpg',
  //   logoW: 150,
  //   logoH: 150,
  //   website: 'https://chabertgroup.com/fr/',
  //   email: 'yT4o2@example.com',
  //   phone: '+33 1 50 50 50 50',
  //   location: 'Nice',
  //   backgroundImages: [
  //     '/partners/chabert/house-1.jpg',
  //     '/partners/chabert/house-10.jpg',
  //     '/partners/chabert/house-11.jpg'
  //   ],
  //   description: {
  //     fr: 'Une Agence familiale mère-fille au coeur de la Riviera',
  //     en: 'A family-owned agency in the heart of the Riviera'
  //   }
  // },
  {
    id: 'rivieraprestige',
    name: 'Riviera Prestige',
    logo: '/partners/riviera/logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.rivieraprestige.fr/',
      en: 'https://www.rivieraprestige.fr/en/'
    },
    email: 'stephane@rivieraprestige.fr',
    phone: '+33 6 62 98 27 46',
    location: 'Cannes',
    backgroundImages: [
      '/partners/riviera/house-2.jpg',
      '/partners/riviera/house-9.jpg',
      '/partners/riviera/house-13.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  },
  {
    id: 'cannisimmo',
    name: 'CannisImmo',
    logo: '/partners/cannisimmo/logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://cannisimmo.com/fr/',
      en: 'https://cannisimmo.com/en/'
    },
    email: 'info@cannisimmo.com',
    phone: '+33 4 92 19 62 55',
    location: 'Cannes Forville – Bocca Sud – Mandelieu',
    backgroundImages: [
      '/partners/cannisimmo/photo-mandelieu.jpg',
      '/partners/cannisimmo/photo-forville.jpg',
      '/partners/cannisimmo/photo-la-bocca.webp'
    ],
    description: {
      fr: '',
      en: ''
    }
  }
]
